export interface WizardStep {
  key: string
  label: string
}

/* The prototype's numbered circles joined by a rule that runs behind them.
   `current` is a zero-based index into `steps`; a value equal to steps.length
   marks every step done, which is what the terminal screens use.

   Shared by the import and export wizards, which have different step lists —
   hence `steps` being a prop rather than a fixed import. The older text-only
   Stepper this replaced has been removed. */
export function BbStepper({ steps, current }: { steps: WizardStep[]; current: number }) {
  return (
    <ol className="bb-steps">
      {steps.map((step, index) => {
        const state = index === current ? ' bb-step-on' : index < current ? ' bb-step-done' : ''
        return (
          <li className={`bb-step${state}`} key={step.key}>
            <span className="bb-step-n" aria-hidden="true">
              {index < current ? '✓' : index + 1}
            </span>
            <span className="bb-step-l">
              {index === current ? <span className="sr-only">Current step: </span> : null}
              {step.label}
            </span>
          </li>
        )
      })}
    </ol>
  )
}
